import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

export type Option = { value: any } & ({ label: string } | { labelKey: string });

@Component({
  selector: 'app-data-filter-select',
  templateUrl: './data-filter-select.component.html',
  styleUrls: ['./data-filter-select.component.scss']
})
export class DataFilterSelectComponent implements OnInit, OnChanges {

  @Input() labelKey: string;
  @Input() model: any;
  @Input() options: Option[] = [];
  @Input() disabled = false;
  @Input() useOptionLabel = false;
  @Input() helperKey: string = null;
  @Input() tooltipKey: string = null;
  @Input() placeholderKey: string = null;
  @Input() emptyOption = false;
  @Input() emptyOptionKey: string;
  @Input() required = false;

  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();

  public showTooltip = false;

  public ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled && this.disabled) {
      this.model = undefined;
      this.change();
    }
  }

  public change(): void  {
    this.modelChange.emit(this.model);
  }

  public toggleTooltip(): void  {
    this.showTooltip = !this.showTooltip;
  }
}
